module.exports = __webpack_public_path__ + "media/img/about/social/blogger-b0e280db27ed42a4371f98dde2051fab.png";